import { CSSProperties } from 'react';

const recipientItemStyle: CSSProperties = {
	fontSize: 13,
	color: '#475569',
	background: '#fff',
	border: '1px solid #e2e8f0',
	borderRadius: 999,
	padding: '2px 10px',
	lineHeight: 1.6,
};

export const ReportEmails = (props: { emails: string[] | null | undefined }) => {
	if (!props.emails?.length) {
		return null;
	}

	return (
		<div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
			{props.emails.map((email) => (
				<span key={email} style={recipientItemStyle}>
					{email}
				</span>
			))}
		</div>
	);
};
